import '@ingka/focus/style.scss';
import '@ingka/switch/style.scss';
import IngkaSwitch from '@ingka/switch';

export default function Switch({props}) {
  return (
    <IngkaSwitch
      {...props}
    />
  )
}
